
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { PieChart, Pie, Cell } from "recharts";
import { TrendingUp } from "lucide-react";

const ProjectAnalytics = () => {
  const timelineData = [
    { month: "Jan", completedProjects: 4, ongoingProjects: 6, efficiency: 85 },
    { month: "Feb", completedProjects: 6, ongoingProjects: 8, efficiency: 82 },
    { month: "Mar", completedProjects: 8, ongoingProjects: 7, efficiency: 88 },
    { month: "Apr", completedProjects: 10, ongoingProjects: 9, efficiency: 90 },
    { month: "May", completedProjects: 7, ongoingProjects: 12, efficiency: 87 },
    { month: "Jun", completedProjects: 12, ongoingProjects: 8, efficiency: 92 },
  ];

  const projectTypes = [
    { name: "Web Development", value: 35 },
    { name: "Mobile Apps", value: 25 },
    { name: "UI/UX Design", value: 20 },
    { name: "Consulting", value: 20 },
  ];

  const COLORS = ["#8b5cf6", "#22c55e", "#3b82f6", "#f97316"];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      <Card className="glass-effect hover:shadow-lg transition-all">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-xl font-semibold">Project Timeline</CardTitle>
          <TrendingUp className="w-5 h-5 text-purple-500" />
        </CardHeader>
        <CardContent>
          <div className="h-[300px]">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={timelineData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                <XAxis dataKey="month" stroke="#6b7280" />
                <YAxis stroke="#6b7280" />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    borderRadius: "8px",
                    border: "none",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="completedProjects"
                  stroke="#8b5cf6"
                  strokeWidth={2}
                  dot={{ r: 4 }}
                  name="Completed"
                />
                <Line
                  type="monotone"
                  dataKey="ongoingProjects"
                  stroke="#22c55e"
                  strokeWidth={2}
                  dot={{ r: 4 }}
                  name="Ongoing"
                />
                <Line
                  type="monotone"
                  dataKey="efficiency"
                  stroke="#3b82f6"
                  strokeWidth={2}
                  dot={{ r: 4 }}
                  name="Efficiency %"
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>

      <Card className="glass-effect hover:shadow-lg transition-all">
        <CardHeader>
          <CardTitle className="text-xl font-semibold">Project Distribution</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-[300px] flex flex-col items-center justify-center">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={projectTypes}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={90}
                  fill="#8884d8"
                  paddingAngle={5}
                  dataKey="value"
                  label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                  labelLine={false}
                >
                  {projectTypes.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProjectAnalytics;
